import Bridge from './bridge';

class UnityPlayActions {
    constructor () {
        this._initialize();
    }

    _initialize () {
        console.debug('[UnityPlayActions._initialize] Initialized');
    }

    sendViewMaximizeAndPlayMessage () {
        console.debug('[UnityPlayActions.sendViewMaximizeAndPlayMessage] Sending MaximizeAndPlay state to Unity');
        Bridge.sendMessage('MaximizeAndPlay');
    }

    sendViewMinimizeMessage () {
        console.debug('[UnityPlayActions.sendViewMinimizeMessage] Sending Minimize state to Unity');
        Bridge.sendMessage('Minimize');
    }
}

export default UnityPlayActions;
